import { render, staticRenderFns } from "./SalesTrendWidget.vue?vue&type=template&id=78279e79&scoped=true"
import script from "./SalesTrendWidget.vue?vue&type=script&lang=js"
export * from "./SalesTrendWidget.vue?vue&type=script&lang=js"
import style0 from "./SalesTrendWidget.vue?vue&type=style&index=0&id=78279e79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78279e79",
  null
  
)

export default component.exports